import PostDetails from "../../components/PostDetails";
import RelatedPost from "../../components/RelatedPost";
import BreadCrumb from "../../components/BreadCrumb";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  fetchSinglePost,
  fetchRelatedPosts,
} from "../../features/BlogDetails/blogDetailsSlice";

export default function PostPage() {
  const { postId } = useParams();
  const dispatch = useDispatch();
  const { post, relatedPosts, relatedPostsError } = useSelector(
    (state) => state.blogsDetails
  );
  const filteredRelatedPosts = relatedPosts.filter(
    (relatedPost) => relatedPost.id !== Number(postId)
  );

  useEffect(() => {
    dispatch(fetchSinglePost(postId));
  }, [postId]);

  useEffect(() => {
    if (post) {
      dispatch(fetchRelatedPosts(post?.tags));
    }
  }, [post]);

  return (
    <>
      <BreadCrumb />
      <section className="post-page-container">
        <PostDetails />

        <aside>
          <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
            Related Posts
          </h4>
          <div className="space-y-4 related-post-container">
            {relatedPostsError && (
              <div className="text-red-500">{relatedPostsError}</div>
            )}

            {!filteredRelatedPosts.length && (
              <div className="text-red-500">No related posts found</div>
            )}

            {!filteredRelatedPosts.length ||
              filteredRelatedPosts.map((relatedPost) => (
                <RelatedPost key={relatedPost.id} relatedPost={relatedPost} />
              ))}
          </div>
        </aside>
      </section>
    </>
  );
}
